import Constants from '../../constants';
//Modules
import React, { useEffect, useContext, useState,useRef } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import Button from '@mui/material/Button';

import { Stimulsoft } from 'stimulsoft-reports-js/Scripts/stimulsoft.viewer';
import 'stimulsoft-reports-js/Css/stimulsoft.viewer.office2013.whiteblue.css';

import { GetReports } from '../../actions/ReportActions';
import { useLocation } from 'react-router';
import { Dialog, DialogActions, DialogContent } from '@mui/material';
import { TextField, CheckboxWithLabel } from 'formik-mui';
import { Form, Formik,Field } from 'formik';
import { useReportUser } from '../../misc/UseFuncs';
import { SendEmail } from '../../actions/OutboundEmailActions';
import { LoadReport,ReportsByTypeName,encode } from './ReportCommon';

function useQuery() {
	const { search } = useLocation();
	return React.useMemo(() => new URLSearchParams(search), [search]);
}

const ReportViewer = props => {
	console.log('check call 1111111111111111');
	const query=useQuery();
	const dispatch=useDispatch();
	const [reportError,setError]=useState(null);
	const [sendOpen,setSendOpen]=useState(false);
	const reportData = useSelector(state => ReportsByTypeName(state, props.type,props.name)); 
	
	
    const options = new Stimulsoft.Viewer.StiViewerOptions();
    options.toolbar.showSendEmailButton = false;
	options.toolbar.showOpenButton=false;
    const viewer = new Stimulsoft.Viewer.StiViewer(options,"StiViewer",false);
	const dumpData=query.get("DumpReportData")
	const sendEmail =()=>setSendOpen(true);
	console.log('check call 1111111111111');
    useEffect(()=>{
		console.log('check call 222222222222222');
		if (!dumpData && reportData) {
			let report=null;
			try{
				report=LoadReport(reportData, props.printData.ReportName, props.printData.Data);
			} catch(e){
				setError(e.message);
			}
			if(reportError===null){
				viewer.report = report;
				viewer.renderHtml("reportViewer");
				
				const userButton = viewer.jsObject.SmallButton("userButton", "Close", "emptyImage"); 
				userButton.image.src = "data:image/png;base64,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";
				userButton.action = function () { props.onClose(); }
				
				const sendButton = viewer.jsObject.SmallButton("emlButton", "SendEmail", "email");
				sendButton.image.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABGdBTUEAAK/INwWK6QAAAPtJREFUeNpi/P//PwMu0N3dzQmkJgMxGxBnlZaWfkFXw4jLAKBmFSC12sTExICJiYnh1KlTd4D8CKAhZwkaANQcAqTmOzo68gANAItdvnyZYceOHb+AzBqgId1YDQBqBDm1XV1dvcjAwIBBTk4OxeCPHz+CXMJw4cKFHUBuHNCg13ADgJpBqlcYGxtb2tnZMbCwsOAMm6NHjzIcO3bsBcgQxq6uLtyhCAUuzs5Yxffs3csAtgboFHwxwWBoZITfABBYfvAOhoJIexUMsQ95XmBaYNI2MM2CTzExgGQXwGzGMIBuLsBpAE1dAIpKilwATCeMeA3AZwMhABBgAFBaZVgK+blxAAAAAElFTkSuQmCC";
				sendButton.action = sendEmail;
				const toolbarTable = viewer.jsObject.controls.toolbar.firstChild.firstChild;
				const buttonsTable = toolbarTable.rows[0].firstChild.firstChild;
		
				
				const sendButtonCell = buttonsTable.rows[0].insertCell(0);
				sendButtonCell.className = "stiJsViewerClearAllStyles";
				sendButtonCell.appendChild(sendButton);
				const userButtonCell = buttonsTable.rows[0].insertCell(0);
				userButtonCell.className = "stiJsViewerClearAllStyles";
				userButtonCell.appendChild(userButton);
			}
		} else {
			setError(<>Could not load report! <Button onClick={()=>{dispatch(GetReports())}}>Reload Reports</Button>  </>);
		}
        
    },[reportData,props.printData.Data]) //DidMount
	if(dumpData){
		return <div>{JSON.stringify(props.printData.Data[reportData.dataSourcesCSV])}</div>;
	}
	console.log("/ViewReport---------------------------");
    return <>
		<div id="reportViewer">{reportError}</div>
		<SendEmailDialog sendOpen={sendOpen} setSendOpen={setSendOpen} reportName={props.printData.ReportName} reportData={reportData} 
		dataSets={props.printData.Data } subject={props.printData.EmailSubject}  />
	</>;
};
const SendEmailDialog = ({ sendOpen, setSendOpen, reportName, reportData,dataSets,subject }) => {
	const handleError = (error) => {
		alert("Render PDF Error");
    }
	const dispatch=useDispatch();
	const userData = useReportUser();
	const initVals={To:userData.email,Cc:'',Subject:subject,Body:'',From:userData.email,Sender:userData.fullName, Phone:userData.phone};
	const onSubmit = (vals) => {

		const report = LoadReport(reportData, reportName, dataSets);
		report.renderAsync(function () {
			report.exportDocumentAsync((pdfData) => {
				
				// Converting Array into buffer
				const pdf64Str = encode(pdfData);
				//const reverse = decode(pdf64Str);
				// File System module
				//var fs = require('fs');
				// Saving string with rendered report in PDF into a file
				//fs.writeFileSync('./SimpleList.pdf', buffer);
				const attachment = { data: pdf64Str, fileName: reportName + ".pdf", mimeType: "application/pdf" };
				dispatch(SendEmail(vals.To, vals.Cc, vals.Subject, vals.Body, [attachment],vals.From,vals.Sender,vals.Phone));
				//Stimulsoft.System.StiObject.saveAs(pdfData, reportName + ".pdf", "application/pdf");
			}, Stimulsoft.Report.StiExportFormat.Pdf);
			setSendOpen(false);
		});
		
	};
	const validate =(values)=>{
		const errors={};
		return errors;
	}
	return <Dialog open={sendOpen} onClose={()=>setSendOpen(false)} fullWidth>
	<Formik initialValues={initVals} onSubmit={onSubmit} validate={validate} >
		<Form>
	<DialogContent > <div>
						<Field  fullWidth
							component={TextField}
							name="To"
							type="text"
							label="To"
						/>
					</div>
					<div>
						<Field fullWidth
							component={TextField}
							name="Cc"
							type="text"
							label="Cc"
						/>
					</div>
					<div>
						<Field  fullWidth
							component={TextField}
							name="Subject"
							type="text"
							label="Subject"
						/>
					</div>
					<div> 
						<Field  fullWidth
							component={TextField}
							name="Body"
							type="text"
							label="Body"
							InputProps={{
								multiline: true,
								rows: 3,
	
							}}
						/>
					</div>
			</DialogContent>
		<DialogActions>
			<Button onClick={()=>setSendOpen(false)}>Cancel</Button>
			<Button type="submit">Send Email</Button>
		</DialogActions>
	</Form>
	</Formik>
</Dialog>;
};

export default ReportViewer;